import { Component, input, ChangeDetectionStrategy } from '@angular/core'
import { FooterClientComponent } from '../../footers/footer-client/footer-client.component'
import { HeaderClientComponent } from '../../headers/header-client/header-client.component'

@Component({
    selector: 'app-layout-client',
    imports: [HeaderClientComponent, FooterClientComponent],
    templateUrl: './layout-client.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './layout-client.component.css',
})
export class LayoutClientComponent {
    pageTitle = input<string>('')
}
